import React from "react";
import "../css/others/Table.css";
import { TableProps } from '../interFaces/interfaces';
const formatDate = (dateString: string | undefined | null): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
const ReusableTable: React.FC<TableProps> = ({ columns = [], data = [], onRowClick, clickableColumn }) => {
  return (
    <div className="table-container">
      <div className="table-inner-container">
        <table className="main-table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index}>
                  {column.headerRender ? column.headerRender(column.label) : column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="no-data">No data available</td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((column, colIndex) => {
                    const cellValue =
                      column.render?.(row[column.key], row) ??
                      (column.key.toLowerCase().includes("date")
                        ? formatDate(row[column.key])
                        : row[column.key] ?? "");
                    return (
                      <td
                        key={colIndex}
                        onClick={() => clickableColumn && column.key === clickableColumn && onRowClick?.(row)}
                        className={clickableColumn && column.key === clickableColumn ? "clickable" : ""}>
                        {cellValue}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default ReusableTable;